import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const donationGoodFields: FieldInterface[] = [
  {
    key: 'amount',
    originKey: 'amount',
    type: FIELD_TYPES.number,
  },
]

const donationGoodRelations: RelationInterface[] = [
  {
    key: '_donation',
    originKey: 'donation',
    objectType: OBJECT_TYPES.donation,
  },
  {
    key: '_good',
    originKey: 'good',
    objectType: OBJECT_TYPES.portfolio,
  },
]

export { donationGoodFields, donationGoodRelations }
